import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EndasureMainComponent } from './endasure-main/endasure-main.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { I18nModule, FeaturesConfigModule, UrlModule, ConfigModule, CmsConfig } from '@spartacus/core';
import { AtMessageModule, IconModule, ItemCounterModule, ListNavigationModule, MediaModule, OutletModule, OutletRefModule, PageComponentModule, PageLayoutModule, SpinnerModule, StarRatingModule } from '@spartacus/storefront';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { EndasureLeftComponent } from './endasure-left/endasure-left.component';
import { EndasureVistorInfoComponent } from './endasure-vistor-info/endasure-vistor-info.component';
import { EndasureFleetInfoComponent } from './endasure-fleet-info/endasure-fleet-info.component';
import { EndasureReplacementCostComponent } from './endasure-replacement-cost/endasure-replacement-cost.component';
import { EndasureCurrentProductComponent } from './endasure-current-product/endasure-current-product.component';
import { EndasureCsaDowntimeComponent } from './endasure-csa-downtime/endasure-csa-downtime.component';
import { EndasureProComponent } from './endasure-pro/endasure-pro.component';
import { EndasureSummaryComponent } from './endasure-summary/endasure-summary.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { EndasureTooltipPopUPComponent } from './endasure-tooltip-pop-up/endasure-tooltip-pop-up.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { EndasureEmailComponent } from './endasure-email/endasure-email.component';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import {
  RECAPTCHA_SETTINGS,
  RecaptchaFormsModule,
  RecaptchaModule,
  RecaptchaSettings,
} from 'ng-recaptcha';
import { EndasureValueDisclaimerComponent } from './endasure-value-disclaimer/endasure-value-disclaimer.component';
import { EnvironmentService } from 'src/app/services/environment.service';

@NgModule({
  declarations: [
    EndasureMainComponent,
    EndasureLeftComponent,
    EndasureVistorInfoComponent,
    EndasureFleetInfoComponent,
    EndasureReplacementCostComponent,
    EndasureCurrentProductComponent,
    EndasureCsaDowntimeComponent,
    EndasureProComponent,
    EndasureSummaryComponent,
    EndasureTooltipPopUPComponent,
    EndasureEmailComponent,
    EndasureValueDisclaimerComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    AtMessageModule,
    FeaturesConfigModule,
    IconModule,
    InfiniteScrollModule,
    ItemCounterModule,
    ListNavigationModule,
    MediaModule,
    OutletModule,
    OutletRefModule,
    PageComponentModule,
    RouterModule,
    SpinnerModule,
    StarRatingModule,
    UrlModule,
    TooltipModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    PageLayoutModule,
    RecaptchaModule,
    RecaptchaFormsModule,

    ConfigModule.withConfig({
      cmsComponents: {
        BendixValueCalculatorFlexComponent: {
          component: EndasureMainComponent, guards: [SecureGuard]
        }
      }
    } as CmsConfig)
  ],
  providers: [ {
    provide: RECAPTCHA_SETTINGS,
    useFactory: (config: EnvironmentService): RecaptchaSettings => {
      return { siteKey: config.getConfig().googleReCaptchaKey };
    },
    deps: [EnvironmentService],
  },
  ],
})
export class EndasureModule { }



